import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { PageSection } from '@gik/ui';

export default function WhySupportMattersSection(): React.ReactElement {
  const bem = bemBlock('why-support-matters-section');
  const { t } = useTranslation();
  return (
    <PageSection variant="solid-neutral" className={bem()}>
      <h2 className={bem('title')}>{t(translationKeys.title)}</h2>
      <div className={bem('description')}>
        <p>{t(translationKeys.description)}</p>
      </div>
    </PageSection>
  );
}
